"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLogout(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M15 0l5 1.5v13L15 16v-1H7v-5h2v3h6V3H9v3H7V1h8zm-5 5l4 3-4 3V9H4V7h6z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Logout')(SvgLogout);
//# sourceMappingURL=Logout.js.map